import { memo } from "react";

import { FormErrorMessage, FormItem, FormLabel, type FormErrorLayout } from "@/components/ui/form/_base/form";
import { FormInputLabelWrapper } from "@/components/ui/form/_base/label/form-wrapper";
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/input/select";

import type { SelectWithOptgroupOption } from "../_type/type";

type SelectWithOptgroupProps = {
	value: unknown;
	placeholder?: string;
	options: SelectWithOptgroupOption[];
	errorMessage: string | undefined;
	errorLayout?: FormErrorLayout;
	handleValueChange: (value: string) => void;

	label?: string;
};

export const SelectWithOptgroup = memo((props: SelectWithOptgroupProps) => {
	const { value, placeholder, options, errorMessage, errorLayout, handleValueChange, label } = props;

	return (
		<FormInputLabelWrapper>
			<FormItem>
				{label && <FormLabel>{label}</FormLabel>}

				<div className="relative">
					<Select onValueChange={handleValueChange} value={String(value)}>
						<div className="w-full">
							<SelectTrigger>
								<SelectValue placeholder={placeholder} />
							</SelectTrigger>
						</div>
						<SelectContent>
							{options.map((item, index) => {
								return (
									<SelectGroup key={item.label + index}>
										<SelectLabel>{item.label}</SelectLabel>
										{item.children.map((child, index) => {
											return (
												<SelectItem value={child.value} key={child.key + index}>
													{String(child.key)}
												</SelectItem>
											);
										})}
									</SelectGroup>
								);
							})}
						</SelectContent>
					</Select>
					<FormErrorMessage layout={errorLayout}>{errorMessage}</FormErrorMessage>
				</div>
			</FormItem>
		</FormInputLabelWrapper>
	);
});
